









































































































































































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, State, Getter, Mutation } from 'vuex-class'
import Rate from '@/modules/shipping/model/Rate'
import Region from '@/modules/shipping/model/Region'
import RateDetailMode from '@/modules/shipping/model/RateDetailMode'
import CarrierSelector from '@/modules/shipping/components/CarrierSelector.vue'
import RegionList from '@/modules/shipping/components/RegionList.vue'
import Modal from '@/components/Modal.vue'
import { CalculationRule } from '@/modules/shipping/model/Rate'
import {CreateListResult} from '@/modules/reservation/model/CreateListResult';
import {Ref} from 'vue-property-decorator';
import {VForm} from '@/types';
import Carrier from '../model/Carrier'

export interface VDataTableHeader {
    sortable: boolean
    align?: string
    value?: string
    text: string
}

interface CreateRangeOptions {
    since: number,
    until: number,
    step: number,
}

/**
 * Detalle de una tarifa
 *
 * Muestra una pantalla para modificar la información, regiones y precios
 * de la tarifa seleccionada por el usuario.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'carrier-selector': CarrierSelector,
        'region-list': RegionList,
        'modal': Modal,
    },
})
export default class RateDetail extends Vue {

    /**
     * Tarifa actualmente en vista/edición
     */
    @State(state => state.shipping.currentRate)
    public rate: Rate

    @State(state => state.shipping.rateDetailMode)
    public mode: RateDetailMode

    @State(state => state.shipping.currentCarrier)
    public currentCarrier: Carrier
    /**
     * Acción que carga la la información de la tarifa
     */
    @Action('shipping/loadRateDetail')
    public loadRateDetail: (id: string) => void

    /**
     * Pesos
     */
    @Getter('shipping/tabulatedWeights')
    public weights: number[]

    @Mutation('shipping/region/weight/set')
    public setWeight: (payload: {region: Region, weight: number, price: number}) => void

    @Mutation('shipping/rate/current/field/update')
    public updateCurrentRateField: (payload: {field: string, value: any}) => void

    /**
     * Elimina un peso de todas las regiones de la tarifa actual
     */
    @Mutation('shipping/REMOVE_WEIGHT_IN_ALL_REGIONS')
    public removeWeightOfAllRegions: (weight: number) => void

    /**
     * Referencia al formulario encargado de validar la configuración para
     * insertar un rango de precios
     */
    @Ref('addPriceRangeForm')
    public addPriceRangeForm: VForm

    public loading = true
    public newWeight = ''
    public createdWeights: number[] = []
    public saveDialog = false
    public newPrice = ''
    public addPriceRangeDialog = false
    public addPriceDialog = false
    public savingRate = false
    public rangeOptions: CreateRangeOptions = {
        since: 0,
        until: 0,
        step: 0,
    }

    public updateCarrier (value: Carrier) {
        this.updateRateField('carrier', value)
        this.$store.dispatch('shipping/updateCurrentCarrier', value)
    }

    public calculationRules = [
        { value: CalculationRule.ByWeight, text: 'Calcular por peso del pedido'},
        { value: CalculationRule.ByAmount, text: 'Calcular por importe del pedido'},
    ]

    public get addPriceRangeFormRules () {
        return [
            (v: string) => !!v || `El ${this.calcByAmount ? 'importe' : 'peso'} no puede estar vacío`,
        ]
    }

    get computedWeights (): number[] {
        return _.sortBy(_.union(this.weights, this.createdWeights))
    }

    get regions (): Region[] {
        if (this.mode === RateDetailMode.Editing) {
            return this.$store.getters['shipping/regionsEditing'](this.rate)
        }
        return this.$store.getters['shipping/regions'](this.rate)
    }

    public validationRules = [
        (v: string) => /[+-]?([0-9]*[.])?[0-9]+/.test(v) || 'El precio debe ser un número',
    ]

    /**
     * Cabeceras de la tabla de precios
     *
     * Genera las cabeceras en base a las regiones registradas en la tarifa
     */
    get headers () {
        const first = {text: this.calcByAmount ? 'Importe (€)' : 'Peso (Kg)', sortable: false}
        const headers: VDataTableHeader[] = this.regions.map(region => {
            return {text: region.name, sortable: false}
        })

        headers.push({ text: 'Acciones', sortable: false, align: 'right'})
        headers.unshift(first)

        return headers
    }

    public updateRateField (field: string, value: any) {
        this.updateCurrentRateField({field, value})
    }

    public async created () {
        if (this.mode === RateDetailMode.Creating || this.mode === RateDetailMode.Editing) {
            this.resetRegions()
        }
        await this.loadRateDetail(this.$router.currentRoute.params.id)
        this.loading = false
        if (this.rate.id != 0 && this.$router.currentRoute.params.id !== 'nueva') {
            this.updateCarrier(this.rate.carrier)
        } else {
            this.updateCarrier(new Carrier(''))
        }

        if (this.mode === RateDetailMode.Editing) {
            const regionsCurrentRate: any = []
            this.regions.forEach((region: Region) => {
                if (region.rate.id === this.rate.id) {
                    regionsCurrentRate.push(region)
                }
            })
            console.log(regionsCurrentRate)
            this.$store.dispatch('shipping/updateRegions', regionsCurrentRate)
        }

    }

    public resetRegions () {
        this.$store.dispatch('shipping/resetRegions')
    }

    public get freeShippingFrom (): any {
        return this.rate.freeShippingFrom
    }

    public set freeShippingFrom (value: any) {
        let number = parseFloat(value)
        if (isNaN(number)) {
            number = 0
        }

        this.updateRateField('freeShippingFrom', number)
    }

    public async save () {
        this.savingRate = true
        switch (this.mode) {
            case RateDetailMode.Editing:
                await this.$store.dispatch('shipping/updateRate')
                break
            case RateDetailMode.Creating:
                await this.$store.dispatch('shipping/createRate')
                // Se añade redirección a la ruta del componente RateDetail rescatando el ID de la tarifa
                // recién creada para que no cree más si modifica la tarifa que acaba de crear y guardar.
                // lanzamos al store un dispatch a la función editRateDetailMode encargada de ejecutar
                // una mutación que modifique el estado de rateDetailMode en store.
                this.$router.push({ name: 'shipping.rate', params: { id: this.$store.state.shipping.currentRate.id } })
                this.$store.dispatch('shipping/editRateDetailMode', RateDetailMode.Editing)
                break
            default:
                this.savingRate = false
                this.saveDialog = false
                throw new Error(`El modo ${this.mode} no es válido`)
        }

        this.savingRate = false
        this.saveDialog = false
    }

    /**
     * Añade un nuevo peso a la tabla de pesos
     */
    public addWeight (weight: string | number = '') {
        const w = weight || this.newWeight

        if (!_.isNumber(w) && !_.isString(w)) {
            this.addPriceDialog = false
            return
        }

        this.createdWeights.push(_.isString(w) ? parseFloat(w) : w)
        this.addPriceDialog = false
    }

    /**
     * Indica si la tarifa calcula los portes por importe de pedido
     */
    public get calcByAmount (): boolean {
        return this.rate.calculationRule === CalculationRule.ByAmount
    }

    /**
     * Elimina un peso de la tabla
     */
    public removeWeight (weight: number) {
        this.removeWeightOfAllRegions(weight)

        // Elimina el peso de la lista de pesos creados en el componente
        const index = this.createdWeights.findIndex(w => w === weight)
        if (index === -1) {
            return
        }

        this.createdWeights.splice(index, 1)
    }

    /**
     * Crea un rango de precios/pesos según la configuración introducida por el usuario e inserta
     * los nuevos valores en la tabla
     */
    public createRange () {
        if (!this.addPriceRangeForm.validate()) {
            return
        }

        const { since, until, step } = this.rangeOptions
        // Ninguno de los valores puede estar vacío
        if (!since || !until || !step) {
            return
        }

        _.range(since, until + step, step).forEach(value => this.addWeight(value))
        this.addPriceRangeDialog = false
    }

    public errorCaptured () {
        this.saveDialog = false
        this.savingRate = false
    }
}
